var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"changeLight",staticClass:"homeText",attrs:{"id":"changeLight"}},[(_vm.$locale)?_c('div',{staticClass:"main"},[_c('div',{staticClass:"homeText__content"},[_c('div',{staticClass:"homeText__text"},[_vm._v(" "+_vm._s(_vm.$locale["home-textBanner"])+" ")])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }